import React from 'react';
import './css/Instructions.scss';
import Progressbar from './Progressbar';

class Instructions extends React.Component {

    constructor( props ) {
        super( props );
        this.state = { position: 0, taskDone: false, activeInstruction: 0 };

        document.addEventListener( "targetClicked", ev => {

            const clicked = ev.detail;
            const currentStage = this.props.Process.tasks[ this.state.position ];

            if ( currentStage.checkCriteria( this.state.activeInstruction, clicked, this.props.scene ) ) {
                this.forceUpdate();
                this.setState( { activeInstruction: this.state.activeInstruction + 1 } );
            }

            const completion = currentStage.completion();

            if ( completion[ 0 ] === completion[ 1 ] && this.state.position + 1 !== this.props.Process.tasks.length ) this.nextStep();

        } )

        document.addEventListener( "Reset", this.reset );

    }

    checkProgress = stage => {

        let i = 0;

        for ( i = 0; stage.instructions.length; i++ ) {

            if ( stage.instructions[ i ].complete ) break;

        }

        return i

    }

    nextStep = () => {

        if ( !this.state.taskDone ) {

            this.setState( { taskDone: true } )
            setTimeout( () => this.setState( { position: this.state.position + 1, activeInstruction: 0 } ), 1750 );
            setTimeout( () => this.setState( { taskDone: false } ), 3000 );

        }

    }

    reset = () => {

        this.setState( { position: 0, activeInstruction: 0 } );
        this.props.Process.tasks.forEach( task => task.reset( this.props.scene ) );

    }

    highlightObject = name => {

        let obj;

        if ( document.querySelector( `[id='${ name }']` ) ) {

            obj = this.props.scene.getObjectByName( name.includes( "keypad" ) ? "NMR Control Tower" : "Computer" );
            if ( this.props.scene.focused === obj ) {

                document.querySelector( `[id='${ name }']` ).classList.add( "highlightHovered" );
                obj = null;

            }

        } else {

            if ( this.props.scene.getObjectByName( name ) ) {

                obj = this.props.scene.getObjectByName( name );
                obj = this.props.scene.focused === obj.parent ? obj : obj.parent;

            }

        }

        if ( !obj ) return;

        //Get screen space to see if in view
        obj.updateMatrixWorld();
        this.props.scene.camera.updateProjectionMatrix();
        const pos = obj.position.clone().set( 0, 0, 0 ).setFromMatrixPosition( obj.matrixWorld );
        pos.project( this.props.scene.camera );

        if ( pos.x > 1 || pos.x < -1 || pos.y > 1 || pos.y < -1 ) {

            document.querySelector( `#DisplayResetCamera` ).classList.add( "highlightHovered" );


        } else {

            this.props.scene.highlighted = obj;

        }

    }

    unhighlightObject = name => {

        this.props.scene.highlighted = null;
        if ( document.querySelector( `[id='${ name }']` ) ) document.querySelector( `[id='${ name }']` ).classList.remove( "highlightHovered" );
        document.querySelector( `#DisplayResetCamera` ).classList.remove( "highlightHovered" );

    }

    render() {

        const currentStage = this.props.Process.tasks[ this.state.position ];

        return (

            <div className={ `Instructions` }>
                <Progressbar tasks={ this.props.Process.tasks } />
                <div id="InstructionsMain" className={ this.state.taskDone ? "CongratsFlash" : "" }>
                    <h1>{ currentStage.title }</h1>
                    <p>{ currentStage.detail }</p>
                    <h2>To-Do</h2>
                    <h3>{ currentStage.completion().join( "/" ) }</h3>
                    <div className="taskList">
                        <ol>
                            { currentStage.instructions.map( ( instruction, i ) => {
                                return (
                                    <li
                                        key={ i }
                                        className={ "task " + ( i === this.state.activeInstruction ? "" : ( instruction.complete ? "task-done" : "task-to-do" ) ) }
                                        onMouseEnter={ () => this.highlightObject( instruction.criteria ) } onMouseLeave={ () => this.unhighlightObject( instruction.criteria ) }
                                    >
                                        { instruction.task }
                                    </li>
                                )
                            } )
                            }
                        </ol>
                    </div>
                </div>
                <h1 id="InstructionsCongrats" className={ this.state.taskDone ? "CongratsFlash" : "" }>Great!</h1>
                <button id="MainMenuButton" onClick={ this.props.toggleMenu }>Back to Main Menu</button>
            </div>

        );
    }
}

export default Instructions;
